import "./components/accordion";
import "./components/slider";
import "./components/sliderConsumables";
import "./components/slider-gentle-cellfab";
import "./components/automationPathways";
// import "./components/automation-steps";
import "./components/automation-steps-desktop";
import "./components/automation-steps-mobile";
// import "./components/productShowcase";
import "./components/builder";
import "./components/hero-slider";

import "./components/slider-circle";

import "./components/testimonials";
import "./components/lottie";
import { gsap } from "gsap";
import { observeAndAnimate, horizontalLoop } from "./components/utils";

// Generic Animation functions
function slideIn ( element ) {
  gsap.to( element, { translateX: 0 } );
}
function slideUp ( element ) {
  gsap.to( element, { translateY: 0 } );
}

function circleImageEffect () {
  const bg = document.querySelector( " .circle-image-effect .yellow-bg" );
  const fg = document.querySelector( " .circle-image-effect .img-fg" );
  if ( bg && fg ) {
    gsap.to( bg, {
      x: 60,
      duration: 1,
      ease: "power2.inOut",
    } );
    gsap.to( fg, {
      x: -60,
      duration: 1,
      ease: "power2.inOut",
    } );
  }
}
observeAndAnimate( ".circle-image-effect", circleImageEffect );
// Observing and animating specific elements
observeAndAnimate( "g.hero-chevron-purple", slideIn );
observeAndAnimate( "g.cta-chevrons", slideIn );
